import { Environment } from './types';

export const firebaseApiKey = 'AIzaSyA4WS6CH4GgTMD_n0qnJ9p6B1srkk5AzzM';
export const stripeSeSKey = 'pk_live_ktk2HFr1a81xbh8P7cl87ndZ';
export const rollbarToken = '9631bf98995142d2a35e9094336ebd13';

/* tslint:disable */
export const environment: Environment = {
  production: true,
  localLogin: false,
  name: 'production',
  products: {
    chatbot: 'https://app.ideta.io',
    privateReplies: 'https://private-replies.ideta.io',
    webhooks: 'https://webhooks.ideta.io',
    livechat: 'https://livechat.ideta.io',
    inbox: 'https://inbox.ideta.io',
    linkedIn: 'https://linkedin.ideta.io/',
    sentimentAnalysis: 'https://api-portal.ideta.io/catalog/prd_t83al06y66emm5k5',
    workflowAnalysis: 'https://api-portal.ideta.io/catalog/prd_hzusd8o2g4sy10d4'
  },
  logos: {
    chatbot: 'assets/img/chatbot.svg',
    privateReplies: 'assets/img/autocomment.png',
    webhooks: 'assets/img/webhooks.svg',
    livechat: 'assets/img/livechat.svg',
    inbox: 'assets/img/inbox.svg',
    linkedIn: 'assets/img/linkedIn_ai.png',
    sentimentAnalysis: 'assets/img/sentiment-analysis.png',
    workflowAnalysis: 'assets/img/workflow-analysis.png'
  },
  domain: 'https://connect.ideta.io',
  backendUrl: 'https://api.ideta.io',
  firebase: {
    authDomain: 'app.ideta.io',
    databaseURL: 'https://ideta-prod.firebaseio.com',
    projectId: 'ideta-prod',
    storageBucket: 'ideta-prod.appspot.com',
    messagingSenderId: '640370672682'
  },
  facebook: {
    appId: '328730850940468',
    xfbml: true,
    version: 'v13.0',
    cookie: true,
    scopes: ['public_profile', 'email', 'pages_messaging', 'pages_show_list', 'pages_manage_metadata', 'pages_read_engagement']
  },
  instagram: {
    scopes: [
      'public_profile',
      'email',
      'pages_messaging',
      'pages_show_list',
      'pages_manage_metadata',
      'pages_read_engagement',
      'instagram_basic',
      'instagram_manage_messages',
      'pages_show_list'
    ]
  },
  rollbar: {
    active: true,
    buildVersion: 'ca51c5f62a'
  },
  defaults: {
    user: {
      avatarUrl: 'assets/img/avatar.svg'
    }
  },
  appSettings: {
    minWidth: 374
  }
};
/* tslint:enable */
